/**
 * Deploy-window guard for the manager's Settings write (#933 D2).
 *
 * Frontends go live on merge, the server on a manual deploy. The browser
 * matrix says a manager holds `business-config:write:all` the moment this code
 * merges, while an older server still answers 403 on every save. So a manager
 * stays read-only until the server says otherwise, in the one way an older
 * server cannot: GET /operations carries `access`. A failed read keeps the old
 * behavior too. The owner never waits on this.
 *
 * Once the server has shipped this is a plain confirmation, and the check can
 * go: `canEdit` in pages/Settings.tsx becomes the matrix answer alone.
 */
import { useEffect, useState } from 'react';
import { adminTenantSettingsApi } from './api.js';

export function useManagerSettingsConfirmed(apiUrl: string, needed: boolean): boolean {
  const [confirmed, setConfirmed] = useState(false);
  useEffect(() => {
    if (!needed) {
      setConfirmed(false);
      return;
    }
    let cancelled = false;
    void adminTenantSettingsApi
      .getOperations(apiUrl)
      .then((res) => {
        if (!cancelled) setConfirmed(res.data?.access?.settings === true);
      })
      .catch(() => {
        if (!cancelled) setConfirmed(false);
      });
    return () => {
      cancelled = true;
    };
  }, [apiUrl, needed]);
  return confirmed;
}
